import { render, staticRenderFns } from "./BaseConformSave.vue?vue&type=template&id=25c065bc&scoped=true"
import script from "./BaseConformSave.vue?vue&type=script&lang=js"
export * from "./BaseConformSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c065bc",
  null
  
)

export default component.exports